import React, { useState ,useEffect} from "react";
import "./Forms.css";

import FormHeading, {
  CancelButton,
  FormButtons,
  PickTime,
  ScheduledInfo,
  SubmitButton,
  SubmittedBox,
} from "../FormComponents/FormComponents";
import CustomCalendar from "../Calendar/CustomCalendar";
import axios from "axios";
import { api_link } from "../../config";
import { useNavigate } from "react-router-dom";

const countryTimeZones = {
  "Afghanistan": "GMT+04:30",
  "Albania": "GMT+01:00",
  "Algeria": "GMT+01:00",
  "Andorra": "GMT+01:00",
  "Angola": "GMT+01:00",
  "Antigua and Barbuda": "GMT-04:00",
  "Argentina": "GMT-03:00",
  "Armenia": "GMT+04:00",
  "Australia": "GMT+10:00",
  "Austria": "GMT+01:00",
  "Azerbaijan": "GMT+04:00",
  "Bahamas": "GMT-05:00",
  "Bahrain": "GMT+03:00",
  "Bangladesh": "GMT+06:00",
  "Barbados": "GMT-04:00",
  "Belarus": "GMT+03:00",
  "Belgium": "GMT+01:00",
  "Belize": "GMT-06:00",
  "Benin": "GMT+01:00",
  "Bhutan": "GMT+06:00",
  "Bolivia": "GMT-04:00",
  "Bosnia and Herzegovina": "GMT+01:00",
  "Botswana": "GMT+02:00",
  "Brazil": "GMT-03:00",
  "Brunei": "GMT+08:00",
  "Bulgaria": "GMT+02:00",
  "Burkina Faso": "GMT+00:00",
  "Burundi": "GMT+02:00",
  "Cabo Verde": "GMT-01:00",
  "Cambodia": "GMT+07:00",
  "Cameroon": "GMT+01:00",
  "Canada": "GMT-05:00 to GMT-08:00",
  "Central African Republic": "GMT+01:00",
  "Chad": "GMT+01:00",
  "Chile": "GMT-04:00",
  "China": "GMT+08:00",
  "Colombia": "GMT-05:00",
  "Comoros": "GMT+03:00",
  "Congo": "GMT+01:00",
  "Costa Rica": "GMT-06:00",
  "Croatia": "GMT+01:00",
  "Cuba": "GMT-05:00",
  "Cyprus": "GMT+02:00",
  "Czech Republic": "GMT+01:00",
  "Denmark": "GMT+01:00",
  "Djibouti": "GMT+03:00",
  "Dominica": "GMT-04:00",
  "Dominican Republic": "GMT-04:00",
  "Ecuador": "GMT-05:00",
  "Egypt": "GMT+02:00",
  "El Salvador": "GMT-06:00",
  "Equatorial Guinea": "GMT+01:00",
  "Eritrea": "GMT+03:00",
  "Estonia": "GMT+02:00",
  "Eswatini": "GMT+02:00",
  "Ethiopia": "GMT+03:00",
  "Fiji": "GMT+12:00",
  "Finland": "GMT+02:00",
  "France": "GMT+01:00",
  "Gabon": "GMT+01:00",
  "Gambia": "GMT+00:00",
  "Georgia": "GMT+04:00",
  "Germany": "GMT+01:00",
  "Ghana": "GMT+00:00",
  "Greece": "GMT+02:00",
  "Grenada": "GMT-04:00",
  "Guatemala": "GMT-06:00",
  "Guinea": "GMT+00:00",
  "Guinea-Bissau": "GMT+00:00",
  "Guyana": "GMT-04:00",
  "Haiti": "GMT-05:00",
  "Honduras": "GMT-06:00",
  "Hungary": "GMT+01:00",
  "Iceland": "GMT+00:00",
  "India": "GMT+05:30",
  "Indonesia": "GMT+07:00 to GMT+09:00",
  "Iran": "GMT+03:30",
  "Iraq": "GMT+03:00",
  "Ireland": "GMT+00:00",
  "Israel": "GMT+02:00",
  "Italy": "GMT+01:00",
  "Jamaica": "GMT-05:00",
  "Japan": "GMT+09:00",
  "Jordan": "GMT+03:00",
  "Kazakhstan": "GMT+05:00 to GMT+06:00",
  "Kenya": "GMT+03:00",
  "Kiribati": "GMT+12:00 to GMT+14:00",
  "North Korea": "GMT+09:00",
  "South Korea": "GMT+09:00",
  "Kosovo": "GMT+01:00",
  "Kuwait": "GMT+03:00",
  "Kyrgyzstan": "GMT+06:00",
  "Laos": "GMT+07:00",
  "Latvia": "GMT+02:00",
  "Lebanon": "GMT+02:00",
  "Lesotho": "GMT+02:00",
  "Liberia": "GMT+00:00",
  "Libya": "GMT+02:00",
  "Liechtenstein": "GMT+01:00",
  "Lithuania": "GMT+02:00",
  "Luxembourg": "GMT+01:00",
  "Madagascar": "GMT+03:00",
  "Malawi": "GMT+02:00",
  "Malaysia": "GMT+08:00",
  "Maldives": "GMT+05:00",
  "Mali": "GMT+00:00",
  "Malta": "GMT+01:00",
  "Marshall Islands": "GMT+12:00",
  "Mauritania": "GMT+00:00",
  "Mauritius": "GMT+04:00",
  "Mexico": "GMT-05:00 to GMT-08:00",
  "Micronesia": "GMT+10:00 to GMT+11:00",
  "Moldova": "GMT+02:00",
  "Monaco": "GMT+01:00",
  "Mongolia": "GMT+07:00 to GMT+08:00",
  "Montenegro": "GMT+01:00",
  "Morocco": "GMT+01:00",
  "Mozambique": "GMT+02:00",
  "Myanmar": "GMT+06:30",
  "Namibia": "GMT+02:00",
  "Nauru": "GMT+12:00",
  "Nepal": "GMT+05:45",
  "Netherlands": "GMT+01:00",
  "New Zealand": "GMT+12:00",
  "Nicaragua": "GMT-06:00",
  "Niger": "GMT+01:00",
  "Nigeria": "GMT+01:00",
  "North Macedonia": "GMT+01:00",
  "Norway": "GMT+01:00",
  "Oman": "GMT+04:00",
  "Pakistan": "GMT+05:00",
  "Palau": "GMT+09:00",
  "Panama": "GMT-05:00",
  "Papua New Guinea": "GMT+10:00",
  "Paraguay": "GMT-04:00",
  "Peru": "GMT-05:00",
  "Philippines": "GMT+08:00",
  "Poland": "GMT+01:00",
  "Portugal": "GMT+00:00",
  "Qatar": "GMT+03:00",
  "Romania": "GMT+02:00",
  "Russia": "GMT+02:00 to GMT+12:00",
  "Rwanda": "GMT+02:00",
  "Saint Kitts and Nevis": "GMT-04:00",
  "Saint Lucia": "GMT-04:00",
  "Saint Vincent and the Grenadines": "GMT-04:00",
  "Samoa": "GMT+13:00",
  "San Marino": "GMT+01:00",
  "Sao Tome and Principe": "GMT+00:00",
  "Saudi Arabia": "GMT+03:00",
  "Senegal": "GMT+00:00",
  "Serbia": "GMT+01:00",
  "Seychelles": "GMT+04:00",
  "Sierra Leone": "GMT+00:00",
  "Singapore": "GMT+08:00",
  "Slovakia": "GMT+01:00",
  "Slovenia": "GMT+01:00",
  "Solomon Islands": "GMT+11:00",
  "Somalia": "GMT+03:00",
  "South Africa": "GMT+02:00",
  "South Sudan": "GMT+03:00",
  "Spain": "GMT+01:00",
  "Sri Lanka": "GMT+05:30",
  "Sudan": "GMT+03:00",
  "Suriname": "GMT-03:00",
  "Sweden": "GMT+01:00",
  "Switzerland": "GMT+01:00",
  "Syria": "GMT+02:00",
  "Taiwan": "GMT+08:00",
  "Tajikistan": "GMT+05:00",
  "Tanzania": "GMT+03:00",
  "Thailand": "GMT+07:00",
  "Timor-Leste": "GMT+09:00",
  "Togo": "GMT+00:00",
  "Tonga": "GMT+13:00",
  "Trinidad and Tobago": "GMT-04:00",
  "Tunisia": "GMT+01:00",
  "Turkey": "GMT+03:00",
  "Turkmenistan": "GMT+05:00",
  "Tuvalu": "GMT+12:00",
  "Uganda": "GMT+03:00",
  "Ukraine": "GMT+02:00",
  "United Arab Emirates": "GMT+04:00",
  "United Kingdom": "GMT+00:00",
  "United States": "GMT-05:00",
  "Uruguay": "GMT-03:00",
  "Uzbekistan": "GMT+05:00",
  "Vanuatu": "GMT+11:00",
  "Vatican City": "GMT+01:00",
  "Venezuela": "GMT-04:00",
  "Vietnam": "GMT+07:00",
  "Yemen": "GMT+03:00",
  "Zambia": "GMT+02:00",
  "Zimbabwe": "GMT+02:00"
};
export default function ScheduleDemo({ setStep }) {

  const [dateSelected, setDateSelected] = useState(new Date());
  const [timeSelected, setTimeSelected] = useState("");
  const [timeZoneSelected, setTimeZoneSelected] = useState("");
  const [durationSelected, setDurationSelected] = useState("15min");
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false); // NEW: loader state
  const navigate = useNavigate();

  useEffect(() => {
    const formData = JSON.parse(sessionStorage.getItem("formData")) || {};
    if (formData.country) {
      formData.country_dropdown = formData.country;
      setTimeZoneSelected(countryTimeZones[formData.country] || "GMT±00:00");
    }
  }, []);
  // Convert time into 24H format
  const convertTo24HourFormat = (time) => {
    const [timePart, modifier] = time.split(" ");
    let [hours, minutes] = timePart.split(":").map(Number);

    if (modifier === "PM" && hours < 12) hours += 12;
    if (modifier === "AM" && hours === 12) hours = 0;

    return `${hours.toString().padStart(2, "0")}:${minutes
      .toString()
      .padStart(2, "0")}`;
  };

  const submitData = async () => {
    setLoading(true); // start loader
    const formData = JSON.parse(sessionStorage.getItem("formData")) || {};
    const storedQaList = JSON.parse(sessionStorage.getItem("qaList")) || [];

    // Update question names if needed
    if (storedQaList[0]) storedQaList[0].question = "all_industry_pillars";
    if (storedQaList[1]) storedQaList[1].question = "what_is_your_key_focus_areas_";
    if (storedQaList[2]) storedQaList[2].question = "in_which_agentic_platform_and_accelerator__you_are_interested_";
    if (storedQaList[3]) storedQaList[3].question = "at_what_stage_does_your_business_belong_to_";
    if (storedQaList[4]) storedQaList[4].question = "at_what_stage_is_your_ai_use_case_currently_in_";
    if (storedQaList[5]) storedQaList[5].question = "what_are_the_primary_challenges_in_adopting_ai_";
    if (storedQaList[6]) storedQaList[6].question = "what_kind_of_infrastructure_does_your_organization_currently_using_";
    if (storedQaList[7]) storedQaList[7].question = "are_you_using_any_data_platform_";
    if (storedQaList[8]) storedQaList[8].question = "preferred_approach_for_ai_transformation";
    if (storedQaList[9]) storedQaList[9].question = "in_which_domain_your_solution_organization_belongs_to_in_terms_of_data_privacy__trustworthy_ai";

    // Define required fields and remove unnecessary keys
    const removeKeys = ["name", "companyName", "jobTitle", "team", "country"];
    const requiredFields = {
      company_name: formData.companyName || "",
      full_name: formData.name || "",
      country_dropdown: formData.country || "",
      jobtitle: formData.jobTitle || "",
      department___team: formData.team || "",
    };

    const updatedFormData = Object.fromEntries(
      Object.entries({ ...formData, ...requiredFields }).filter(([key]) => !removeKeys.includes(key))
    );

    // Create question-answer object
    const qaObject = storedQaList.reduce((acc, item) => {
      acc[item.question] = item.answer || "";
      return acc;
    }, {});

    const formDataCombined = { ...updatedFormData, ...qaObject };
    const finalFormData = {
      fields: Object.entries(formDataCombined).map(([key, value]) => ({
        name: key,
        value: value,
      })),
    };

    // Log finalFormData for debugging
    console.log("Final FormData being sent to HubSpot:", finalFormData);

    try {
      // Send the main form data to HubSpot
      await axios.post(`${api_link}`, finalFormData);
    } catch (error) {
      console.error("Error submitting form data:", error.response?.data || error.message);
      setLoading(false); // stop loader before navigating
      navigate("/error");
      return;
    }

    // Meeting scheduling data preparation
    const formattedDate = `${dateSelected.getFullYear()}-${String(
      dateSelected.getMonth() + 1
    ).padStart(2, "0")}-${String(dateSelected.getDate()).padStart(2, "0")}`;
    const dateTime = `${formattedDate}T${convertTo24HourFormat(timeSelected)}`;
    const meetingData = {
      user_email: formData.email,
      date_time: dateTime,
      time_zone: timeZoneSelected,
      duration: durationSelected.slice(0, -2),
    };

    try {
      // Send meeting scheduling data
      const response = await axios.post("https://application.xenonstack.ai/v1/open/meeting", meetingData);
      console.log("Meeting Data Submitted", response);
      setSubmitted(true);
      setLoading(false); // stop loader on success
      sessionStorage.clear();
    } catch (error) {
      console.error("Error submitting meeting data:", error.response?.data || error.message);
      setLoading(false); // stop loader before navigating
      navigate("/error");
      return;
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (timeSelected.charAt(0) === "N") {
      alert("No available time slots for the selected date.");
      return;
    }
    submitData();
  };

  return (
    <div className="schedule-demo-wrapper" style={{ position: "relative" }}>
      {/* Lightweight overlay loader */}
      {loading && (
        <div
          role="status"
          aria-live="assertive"
          aria-label="Scheduling your demo"
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(255,255,255,0.6)",
            zIndex: 9999,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
            backdropFilter: "blur(1px)",
          }}
        >
          {/* SVG spinner without external CSS */}
          <svg
            width="56"
            height="56"
            viewBox="0 0 44 44"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
          >
            <g fill="none" fillRule="evenodd" strokeWidth="4">
              <circle cx="22" cy="22" r="20" stroke="currentColor" opacity="0.2" />
              <path d="M42 22c0-11.046-8.954-20-20-20" stroke="currentColor">
                <animateTransform
                  attributeName="transform"
                  type="rotate"
                  from="0 22 22"
                  to="360 22 22"
                  dur="0.9s"
                  repeatCount="indefinite"
                />
              </path>
            </g>
          </svg>
          <div
            style={{
              marginTop: 12,
              fontSize: 14,
              color: "#111827",
              fontWeight: 500,
            }}
          >
            Scheduling your demo…
          </div>
        </div>
      )}

      <FormHeading h3="Schedule Demo" />
      <div className="schedule-demo-top" aria-disabled={loading}>
        <div className="schedule-demo-left" style={{ pointerEvents: loading ? "none" : "auto", opacity: loading ? 0.5 : 1 }}>
          <CustomCalendar setDateSelected={(date) => setDateSelected(date)} />
        </div>
        <div className="schedule-demo-right" style={{ pointerEvents: loading ? "none" : "auto", opacity: loading ? 0.5 : 1 }}>
          <PickTime
            setTimeSelected={(time) => setTimeSelected(time)}
            setTimeZoneSelected={(timezone) => setTimeZoneSelected(timezone)}
            setDurationSelected={(duration) => setDurationSelected(duration)}
            selectedDate={dateSelected}
            selectedTimeZone={timeZoneSelected}
          />
        </div>
      </div>

      <div className="schedule-demo-bottom" aria-disabled={loading} style={{ opacity: loading ? 0.6 : 1 }}>
        <ScheduledInfo
          dateSelected={dateSelected}
          timeSelected={timeSelected}
          timeZoneSelected={timeZoneSelected}
        />
        <FormButtons>
          <CancelButton name="Back" onClick={() => !loading && setStep(2)} disabled={loading} />
          <SubmitButton name={loading ? "Scheduling…" : "Schedule Demo"} onClick={handleSubmit} disabled={loading} />
        </FormButtons>
      </div>

      {submitted && (
        <SubmittedBox
          setStep={setStep}
          dateSelected={dateSelected}
          timeSelected={timeSelected}
          timeZoneSelected={timeZoneSelected}
        />
      )}
    </div>
  );
}
